export interface LoadingsState {
  [name: string]: number;
}

export const loadingsState: LoadingsState = {};
